export const marineLife = [
  {
    questionText: "What color is the crab?",
    answerOptions: [
      { answerText: "Blue", isCorrect: false },
      { answerText: "Yellow", isCorrect: false },
      { answerText: "Red", isCorrect: true },
      { answerText: "White", isCorrect: false },
    ],
  },
  {
    questionText: "How many legs does an octopus have?",
    answerOptions: [
      { answerText: "Seven", isCorrect: false },
      { answerText: "Eight", isCorrect: true },
      { answerText: "Nine", isCorrect: false },
      { answerText: "Six", isCorrect: false },
    ],
  },
  {
    questionText: "What is the big fish that looks like a shark?",
    answerOptions: [
      { answerText: "Dolphin", isCorrect: true },
      { answerText: "Nemo", isCorrect: false },
      { answerText: "Shrimp", isCorrect: false },
      { answerText: "Salmon", isCorrect: false },
    ],
  },
  {
    questionText: "Where does a Shark lives?",
    answerOptions: [
      { answerText: "Only River", isCorrect: false },
      { answerText: "River and Sea", isCorrect: false },
      { answerText: "Aquarium", isCorrect: false },
      { answerText: "Only Sea", isCorrect: true },
    ],
  },
  {
    questionText: "Can a starfish swim?",
    answerOptions: [
      { answerText: "Yes! Like a fish!", isCorrect: false },
      { answerText: "No! They don't move", isCorrect: false },
      { answerText: "No! But they move", isCorrect: true },
      { answerText: "No! They are not alive", isCorrect: false },
    ],
  },
  {
    questionText: "Do fish live in water or on land?",
    answerOptions: [
      { answerText: "Only water", isCorrect: true },
      { answerText: "Only land", isCorrect: false },
      { answerText: "Water and land", isCorrect: false },
      { answerText: "Water, Land and Sky", isCorrect: false },
    ],
  },
  {
    questionText: "What do we call a artificial home for fish?",
    answerOptions: [
      { answerText: "Bucket", isCorrect: false },
      { answerText: "Appartment", isCorrect: false },
      { answerText: "House", isCorrect: false },
      { answerText: "Aquarium", isCorrect: true },
    ],
  },
  {
    questionText: "What sea creature has a shell and moves slowly?",
    answerOptions: [
      { answerText: "Whale", isCorrect: false },
      { answerText: "Turtle", isCorrect: true },
      { answerText: "Crab", isCorrect: false },
      { answerText: "Shark", isCorrect: false },
    ],
  },
  {
    questionText:
      "What's the name of the sea creature that looks like a snake?",
    answerOptions: [
      { answerText: "Sea spider", isCorrect: false },
      { answerText: "Sea Cobra", isCorrect: false },
      { answerText: "Shrimp", isCorrect: false },
      { answerText: "Eel", isCorrect: true },
    ],
  },
  {
    questionText: "What sea creature that has a lot of sharp teeth?",
    answerOptions: [
      { answerText: "Shark", isCorrect: true },
      { answerText: "Crab", isCorrect: false },
      { answerText: "Sea wolf", isCorrect: false },
      { answerText: "Sea horse", isCorrect: false },
    ],
  },
  {
    questionText: "What do you call a baby fish?",
    answerOptions: [
      { answerText: "Fish Egg", isCorrect: false },
      { answerText: "Baby Shark", isCorrect: false },
      { answerText: "Fry", isCorrect: true },
      { answerText: "Sea baby", isCorrect: false },
    ],
  },

  {
    questionText: "What sea creature has ten arms and squirts ink?",
    answerOptions: [
      { answerText: "Squid", isCorrect: true },
      { answerText: "Shark", isCorrect: false },
      { answerText: "Turtle, Sand and Concrete", isCorrect: false },
      { answerText: "Crab", isCorrect: false },
    ],
  },
  {
    questionText: "What type of fish Nemo is?",
    answerOptions: [
      { answerText: "pufferfish", isCorrect: false },
      { answerText: "Swardfish", isCorrect: false },
      { answerText: "clownfish", isCorrect: true },
      { answerText: "Startfish", isCorrect: false },
    ],
  },
  {
    questionText:
      "What sea animal is known for its big, round shell and spikes?",
    answerOptions: [
      { answerText: "Turtle", isCorrect: false },
      { answerText: "Sea urchin", isCorrect: true },
      { answerText: "Crab", isCorrect: false },
      { answerText: "Reef", isCorrect: false },
    ],
  },
  {
    questionText: "What sea creature can change its color to hide?",
    answerOptions: [
      { answerText: "Chameleon", isCorrect: false },
      { answerText: "Octopus", isCorrect: true },
      { answerText: "King Crab", isCorrect: false },
      { answerText: "Squid", isCorrect: false },
    ],
  },
  {
    questionText: "What's the biggest animal in the ocean?",
    answerOptions: [
      { answerText: "White Shark", isCorrect: false },
      { answerText: "Pink Whale", isCorrect: false },
      { answerText: "King Crab", isCorrect: false },
      { answerText: "Blue Whale", isCorrect: true },
    ],
  },
  {
    questionText: "What do you call the place where coral lives?",
    answerOptions: [
      { answerText: "House", isCorrect: false },
      { answerText: "Appartment", isCorrect: false },
      { answerText: "Reef", isCorrect: true },
      { answerText: "Home", isCorrect: false },
    ],
  },
  {
    questionText: "What do you call the flippers on a turtle?",
    answerOptions: [
      { answerText: "Fins", isCorrect: true },
      { answerText: "Turtle Shoes", isCorrect: false },
      { answerText: "Legs", isCorrect: false },
      { answerText: "Hands", isCorrect: false },
    ],
  },
  {
    questionText: "What do fish use to breathe?",
    answerOptions: [
      { answerText: "Lungs", isCorrect: false },
      { answerText: "Mouth", isCorrect: false },
      { answerText: "Nose", isCorrect: false },
      { answerText: "Gills", isCorrect: true },
    ],
  },
  {
    questionText: "How many arms does a squid have?",
    answerOptions: [
      { answerText: "Two", isCorrect: false },
      { answerText: "Four", isCorrect: false },
      { answerText: "Six", isCorrect: false },
      { answerText: "Ten", isCorrect: true },
    ],
  },
  {
    questionText: "What do turtles have on their backs?",
    answerOptions: [
      { answerText: "A house", isCorrect: false },
      { answerText: "A sea wing", isCorrect: false },
      { answerText: "A wheel", isCorrect: false },
      { answerText: "A shell", isCorrect: true },
    ],
  },
  {
    questionText: "What do crabs have that helps them grab things?",
    answerOptions: [
      { answerText: "Paws", isCorrect: false },
      { answerText: "Fins", isCorrect: false },
      { answerText: "Hands", isCorrect: false },
      { answerText: "Claws", isCorrect: true },
    ],
  },
  {
    questionText: "What shape is a jellyfish?",
    answerOptions: [
      { answerText: "Round", isCorrect: true },
      { answerText: "Square", isCorrect: false },
      { answerText: "Triangle", isCorrect: false },
      { answerText: "Oval", isCorrect: false },
    ],
  },
  {
    questionText: "What do we call a group of fish?",
    answerOptions: [
      { answerText: "A school", isCorrect: true },
      { answerText: "A flock", isCorrect: false },
      { answerText: "A pack", isCorrect: false },
      { answerText: "A herd", isCorrect: false },
    ],
  },
];
